<template>
  <div class="homeInfo">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table align-middle">
              <thead>
                <tr>
                  <th scope="col">區塊名稱</th>
                  <th scope="col">說明</th>
                  <th scope="col" style="width: 60px">功能</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="homeInfo[clientId].slideshow">
                  <td>主圖輪播</td>
                  <td v-html="homeInfo[clientId].slideshow.instruction" />
                  <td>
                    <button
                      class="btn btn-link p-2"
                      @click="showModal('slideshow')"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="homeInfo[clientId].product_category">
                  <td>產品分類顯示設定</td>
                  <td
                    v-html="homeInfo[clientId].product_category.instruction"
                  />
                  <td>
                    <button
                      class="btn btn-link p-2"
                      @click="showModal('product_category')"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="homeInfo[clientId].article">
                  <td>文章顯示設定</td>
                  <td v-html="homeInfo[clientId].article.instruction" />
                  <td>
                    <button
                      class="btn btn-link p-2"
                      @click="showModal('article')"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="homeInfo[clientId].description">
                  <td>關於我們</td>
                  <td v-html="homeInfo[clientId].description.instruction" />
                  <td>
                    <button
                      class="btn btn-link p-2"
                      @click="showModal('description')"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="slideshowModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="slideshowModal"
    >
      <div
        class="modal-dialog modal-lg modal-fullscreen-lg-down modal-dialog-scrollable"
      >
        <div
          class="modal-content"
          v-if="form && form.slideshow && homeInfo[clientId].slideshow"
        >
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">主圖輪播</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-center">
            <div class="table-responsive">
              <table class="table align-middle text-nowrap border">
                <caption v-html="homeInfo[clientId].slideshow.instruction" />
                <thead>
                  <tr>
                    <th scope="col" class="text-center" style="width: 54px">
                      排序
                    </th>
                    <th scope="col" style="width: 220px">電腦圖片</th>
                    <th scope="col" style="width: 120px">手機圖片</th>
                    <th scope="col" style="width: 283px">連結</th>
                    <th scope="col" style="width: 60px">移除</th>
                  </tr>
                </thead>
                <draggable
                  tag="tbody"
                  v-model="form.slideshow"
                  handle=".drag"
                  animation="1000"
                >
                  <tr
                    v-for="(table, index) in form.slideshow"
                    :key="'slideshow' + index"
                  >
                    <td class="drag text-center" style="cursor: all-scroll">
                      <i class="bi bi-arrows-move"></i>
                    </td>
                    <td class="text-center">
                      <label
                        :for="'imagePcFile' + index"
                        class="imgBox"
                        style="width: 200px; cursor: pointer"
                      >
                        <div class="imgBox-inner">
                          <div class="imgBox-fit" style="padding-top: 46%">
                            <img v-if="table['pc']" :src="table['pc']" alt="" />
                            <i v-else class="bi bi-image"></i>
                          </div>
                        </div>
                      </label>
                      <input
                        class="form-control d-none"
                        type="file"
                        :id="'imagePcFile' + index"
                        accept="image/png, image/jpeg"
                        @change="onFileChange($event.target, 'pc', index)"
                      />
                    </td>
                    <td class="text-center">
                      <label
                        :for="'imageMbFile' + index"
                        class="imgBox"
                        style="width: 95px; cursor: pointer"
                      >
                        <div class="imgBox-inner">
                          <div class="imgBox-fit" style="padding-top: 131%">
                            <img
                              v-if="table['mobile']"
                              :src="table['mobile']"
                              alt=""
                            />
                            <i v-else class="bi bi-image"></i>
                          </div>
                        </div>
                      </label>
                      <input
                        class="form-control d-none"
                        type="file"
                        :id="'imageMbFile' + index"
                        accept="image/png, image/jpeg"
                        @change="onFileChange($event.target, 'mobile', index)"
                      />
                    </td>
                    <td>
                      <input
                        v-model="table.href"
                        type="text"
                        class="form-control"
                      />
                    </td>
                    <td>
                      <button
                        class="btn btn-close p-2"
                        @click="deleteItem(index)"
                      ></button>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              @click="addItem"
              type="button"
              class="btn btn-outline-primary"
              v-if="
                form &&
                (!form.slideshow ||
                  form.slideshow.length < homeInfo[clientId].slideshow.quantity)
              "
            >
              新增
            </button>
            <button
              type="button"
              class="btn btn-outline-gray ms-auto"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button @click="save" type="button" class="btn btn-primary">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="product_categoryModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="product_categoryModal"
    >
      <div class="modal-dialog">
        <div
          class="modal-content"
          v-if="
            form && form.product_category && homeInfo[clientId].product_category
          "
        >
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">產品分類顯示設定</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-center">
            <div class="table-responsive">
              <table class="table align-middle text-nowrap border">
                <caption
                  v-html="homeInfo[clientId].product_category.instruction"
                />
                <thead>
                  <tr>
                    <th scope="col" class="text-center" style="width: 54px">
                      排序
                    </th>
                    <th scope="col">產品分類</th>
                    <th scope="col" style="width: 54px">移除</th>
                  </tr>
                </thead>
                <draggable
                  tag="tbody"
                  v-model="form.product_category"
                  handle=".drag"
                  animation="1000"
                >
                  <tr
                    v-for="(product_category, index) in form.product_category"
                    :key="'product_category' + index"
                  >
                    <td class="drag text-center" style="cursor: all-scroll">
                      <i class="bi bi-arrows-move"></i>
                    </td>
                    <td>
                      <select
                        v-model="form.product_category[index]"
                        class="form-select"
                        aria-label="Default select example"
                        v-if="productCategory"
                      >
                        <option value="">請選擇</option>
                        <option
                          v-for="category in productCategory"
                          :value="category.id"
                          :key="'productCategory' + category.id"
                        >
                          {{ category.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <button
                        class="btn btn-close p-2"
                        @click="deleteItem(index)"
                      ></button>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              @click="addItem"
              type="button"
              class="btn btn-outline-primary"
              v-if="
                form &&
                (!form.product_category ||
                  form.product_category.length <
                    homeInfo[clientId].product_category.quantity)
              "
            >
              新增
            </button>
            <button
              type="button"
              class="btn btn-outline-gray ms-auto"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button @click="save" type="button" class="btn btn-primary">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="articleModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="articleModal"
    >
      <div class="modal-dialog">
        <div
          class="modal-content"
          v-if="form && form.article && homeInfo[clientId].article"
        >
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">文章顯示設定</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-center">
            <div class="table-responsive">
              <table class="table align-middle text-nowrap border">
                <caption v-html="homeInfo[clientId].article.instruction" />
                <thead>
                  <tr>
                    <th scope="col" class="text-center" style="width: 54px">
                      排序
                    </th>
                    <th scope="col">文章名稱</th>
                    <th scope="col" style="width: 54px">移除</th>
                  </tr>
                </thead>
                <draggable
                  tag="tbody"
                  v-model="form.article"
                  handle=".drag"
                  animation="1000"
                >
                  <tr
                    v-for="(article, index) in form.article"
                    :key="'article' + index"
                  >
                    <td class="drag text-center" style="cursor: all-scroll">
                      <i class="bi bi-arrows-move"></i>
                    </td>
                    <td>
                      <v-select
                        v-if="articleSelect && articleSelected"
                        v-model="articleSelected[index]"
                        :options="articleSelect"
                        placeholder="請選擇"
                        @input="pushFormArticle()"
                      >
                      </v-select>
                    </td>
                    <td>
                      <button
                        class="btn btn-close p-2"
                        @click="deleteItem(index)"
                      ></button>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              @click="addItem"
              type="button"
              class="btn btn-outline-primary"
              v-if="
                form &&
                (!form.article ||
                  form.article.length < homeInfo[clientId].article.quantity)
              "
            >
              新增
            </button>
            <button
              type="button"
              class="btn btn-outline-gray ms-auto"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button @click="save" type="button" class="btn btn-primary">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="descriptionModal"
      tabindex="-1"
      ref="descriptionModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" v-if="form">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">關於我們首頁簡介</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <quill v-model="form.description" />
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-gray ms-auto"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button @click="save" type="button" class="btn btn-primary">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { home } from '@/http/api/home.js'
import { product } from '@/http/api/product.js'
import { article } from '@/http/api/article.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { Modal } from 'bootstrap'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import quill from '@/components/plugin/Quill.vue'

const defaultModalDate = {
  article: [],
  description: '',
  product_category: [],
  slideshow: []
}

const slideshowTemplate = {
  pc: '',
  mobile: '',
  url: ''
}

export default {
  name: 'HomeInfo',
  components: {
    draggable,
    vSelect,
    quill,
    Title,
    Breadcrumb
  },
  data () {
    return {
      article: null,
      articleSelected: null,
      bootstrap_modal: null,
      errMsg: null,
      errMsgKey: {
        article: '文章顯示設定',
        description: '關於我們',
        product_category: '產品分類顯示設定',
        slideshow: '主圖輪播'
      },
      form: JSON.parse(JSON.stringify(defaultModalDate)),
      homeInfo: {
        furniture: {
          slideshow: {
            instruction: `
              最多五張圖片，可設定連結
              <br />
              建議尺寸：電腦圖片 1920 x 1080 px、手機圖片 500 x 700 px
              <br />
              ( 高度可以配合客戶的喜好自行調整 )
              <br />
              圖片格式：JPG、PNG
              <br />
              檔案大小建議：在保持解析度的條件下容量越小越好，會影響seo分數
              <br />
              <a href="https://tinypng.com/" target="_blank"
                >(免費壓縮網址)</a
              >
            `,
            quantity: 5
          },
          product_category: {
            instruction: '可選擇六個產品分類於首頁顯示',
            quantity: 6
          },
          article: {
            instruction: '可選擇四篇文章於首頁顯示',
            quantity: 4
          },
          description: {
            instruction: '首頁簡介'
          }
        },
        acadiatravel: {
          slideshow: {
            instruction: `
              最多五張圖片，可設定連結
              <br />
              建議尺寸：電腦圖片 1920 x 1080 px、手機圖片 500 x 700 px
              <br />
              ( 高度可以配合客戶的喜好自行調整 )
              <br />
              圖片格式：JPG、PNG
              <br />
              檔案大小建議：在保持解析度的條件下容量越小越好，會影響seo分數
              <br />
              <a href="https://tinypng.com/" target="_blank"
                >(免費壓縮網址)</a
              >
            `,
            quantity: 5
          },
          description: {
            instruction: '首頁簡介'
          }
        }
      },
      productCategory: null,
      showModalType: null // slideshow、article、product_category、description
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['clientId', 'errMsgInfo']),
    articleSelect () {
      const array = []
      if (this.article) {
        this.article.forEach((article) => {
          array.push({
            label: article.title,
            value: article.id
          })
        })
      }
      return array
    }
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    'form.article': function (data) {
      const vm = this
      if (data) {
        vm.getArticleSelected()
      }
    }
  },
  methods: {
    ...mapMutations([
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey'
    ]),
    ...mapActions(['uploadImage']),
    initialEvent () {
      const vm = this
      vm.getProductCategory()
      vm.getHomeInfo()
    },
    showModal (modalType) {
      const vm = this
      vm.bootstrap_modal = new Modal(vm.$refs[`${modalType}Modal`], {
        backdrop: 'static',
        keyboard: false
      })
      vm.bootstrap_modal.show()
      vm.showModalType = modalType
    },
    addItem () {
      const vm = this
      switch (vm.showModalType) {
        case 'slideshow':
          vm.form.slideshow.push(JSON.parse(JSON.stringify(slideshowTemplate)))
          break
        case 'article':
          vm.form.article.push('')
          break
        case 'product_category':
          vm.form.product_category.push('')
          break
        default:
          break
      }
    },
    deleteItem (index) {
      const vm = this
      vm.form[vm.showModalType].splice(index, 1)
    },
    getHomeInfo () {
      const vm = this
      home
        .get(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.form = res.data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getProductCategory () {
      const vm = this
      product
        .getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.productCategory = data.data.filter(
              (category) => category.parent_id === 0
            )
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getArticle () {
      const vm = this
      return new Promise((resolve) => {
        article
          .get('', vm.token)
          .then((res) => {
            const { data } = res
            if (res.status <= 201 && data.status === 'success') {
              vm.article = data.data
              resolve(data.data)
            } else {
              vm.SetErrMsg(data.errMsg)
              vm.AlertsInfo({
                state: 'error',
                title: '失敗 ' + res.status,
                info: vm.errMsgInfo
              })
              vm.Alerted()
            }
            vm.Loaded()
          })
          .catch((err) => {
            vm.SetErrMsg(err)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗',
              info: vm.errMsgInfo
            })
            vm.Alerted()
            vm.Loaded()
          })
      })
    },
    async getArticleSelected () {
      const vm = this
      if (!vm.article) {
        await vm.getArticle()
      }
      if (vm.form && vm.form.article) {
        vm.articleSelected = []
        vm.form.article.forEach((formArticleId) => {
          vm.article.forEach((article) => {
            if (Number(formArticleId) === Number(article.id)) {
              vm.articleSelected.push({
                label: article.title,
                value: article.id
              })
            }
          })
        })
      }
    },
    pushFormArticle () {
      const vm = this
      if (vm.articleSelected) {
        vm.articleSelected.forEach((selected, index) => {
          vm.form.article.splice(index, 1, selected.value)
        })
      }
    },
    save () {
      const vm = this
      vm.Loading()
      home
        .update(vm.form, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    onFileChange (event, type, index) {
      const vm = this
      vm.uploadImage(event).then((value) => {
        if (value) {
          vm.form.slideshow[index][type] = value
        }
      })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
    document.querySelectorAll('.modal').forEach((element) => {
      element.addEventListener('hidden.bs.modal', () => {
        vm.getHomeInfo()
      })
    })
  }
}
</script>
